let storageDomain = '';
let storageDomainAssets = '';
export function setStorageUrl(bucket, region) {
  storageDomain = `https://${bucket}.s3.${region}.amazonaws.com`;
}
export function setStorageDomain(domain, domainAssets) {
  storageDomain = domain;
  storageDomainAssets = domainAssets;
}

export function getStorageUrl(appendUrl = '') {
  if (!appendUrl) {
    return storageDomain;
  }

  if (appendUrl.startsWith('http://') || appendUrl.startsWith('https://')) {
    return appendUrl;
  }
  if (storageDomain.endsWith('/')) {
    storageDomain = storageDomain.substring(0, storageDomain.length - 1);
  }

  const domain = appendUrl.startsWith('assets/') ? storageDomainAssets : storageDomain;

  return mergePathnameSegments([domain, appendUrl]);
}

export function mergePathnameSegments(segments = []) {
  return segments
    .map((segment) => {
      if (segment.startsWith('/')) {
        segment = segment.substring(1);
      }
      if (segment.endsWith('/')) {
        segment = segment.substring(0, segment.length - 1);
      }
      return segment;
    })
    .filter((segment) => !!segment)
    .join('/');
}
